import { render, staticRenderFns } from "./EdutalkRefundProgram.vue?vue&type=template&id=775928e6&scoped=true"
import script from "./EdutalkRefundProgram.vue?vue&type=script&lang=js"
export * from "./EdutalkRefundProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775928e6",
  null
  
)

export default component.exports